export class PoliceManifestation {
    get id() {
        return this.policeManifestationState.id;
    }
    get diligenceNumber() {
        return this.policeManifestationState.diligenceNumber;
    }
    get manifestation() {
        return this.policeManifestationState.manifestation;
    }
    get type() {
        return this.policeManifestationState.type;
    }
    get dateCreated() {
        return this.policeManifestationState.dateCreated;
    }
    get present() {
        return this.policeManifestationState.present;
    }
    get delivery() {
        return this.policeManifestationState.delivery;
    }
    get dateAppointment() {
        return this.policeManifestationState.dateAppointment;
    }
    get userId() {
        return this.policeManifestationState.userId;
    }
    set diligenceNumber(diligenceNumber) {
        this.policeManifestationState.diligenceNumber = diligenceNumber;
    }
    set manifestation(manifestation) {
        this.policeManifestationState.manifestation = manifestation;
    }
    set type(type) {
        this.policeManifestationState.type = type;
    }
    set dateCreated(dateCreated) {
        this.policeManifestationState.dateCreated = dateCreated;
    }
    set present(present) {
        this.policeManifestationState.present = present;
    }
    set delivery(delivery) {
        this.policeManifestationState.delivery = delivery;
    }
    set dateAppointment(dateAppointment) {
        this.policeManifestationState.dateAppointment = dateAppointment;
    }
    set userId(userId) {
        this.policeManifestationState.userId = userId;
    }
    constructor(policeManifestationState) {
        this.policeManifestationState = policeManifestationState;
    }
    getState() {
        return this.policeManifestationState;
    }
}
